import { getTypeOfApplication } from './states';

export const services = {
  getTypeOfApplication,
};
